
export const authorize = {
  uri: 'https://open.weixin.qq.com/connect/oauth2/authorize?',
  appid: '',
  state: 0,
};
